import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentUser } from '@/hooks';

import type { PropsWithChildren } from 'react';

import LoadingCover from '@/components/Layouts/Loading';
import { hasGlobalRole, isAdmin, isSupport } from '@/types/user';

const RequireAdminOrSupport = ({
  children,
  globalOnly = false,
}: PropsWithChildren<{ globalOnly?: boolean }>) => {
  const { user, isUserLoading } = useCurrentUser();
  const navigate = useNavigate();
  const canManage = globalOnly
    ? hasGlobalRole(user, 'admin') || hasGlobalRole(user, 'support')
    : isAdmin(user) || isSupport(user);

  useEffect(() => {
    if (!isUserLoading && (!user.id || !canManage)) {
      navigate('/', { replace: true });
    }
  }, [canManage, isUserLoading, navigate, user.id]);

  if (isUserLoading) return <LoadingCover />;

  return canManage ? children : null;
};

export default RequireAdminOrSupport;
